/**
 * SCM 待审记录列表表格
 */

import React from 'react';
import { Table, Tag, Space, Button, Popconfirm, Typography } from 'antd';
import { EyeOutlined, StopOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import PermissionGuard from '../../../../components/auth/PermissionGuard';

const { Text } = Typography;

const SOURCE_MAP = {
    email: { label: '邮件', color: 'blue' },
    manual: { label: '人工', color: 'green' },
};

const STATUS_MAP = {
    pending: { label: '待处理', color: 'processing' },
    confirmed: { label: '已确认', color: 'success' },
    ignored: { label: '已忽略', color: 'default' },
    parse_failed: { label: '解析失败', color: 'error' },
};

const renderTag = (map, value) => {
    const item = map[value] || {};
    return <Tag color={item.color}>{item.label || value || '-'}</Tag>;
};

const ScmInboundTable = ({
    dataSource,
    loading,
    pagination,
    onChange,
    onView,
    onIgnore,
}) => {
    const columns = [
        {
            title: '站点',
            dataIndex: 'station',
            key: 'station',
            width: 70,
            fixed: 'left',
            render: (v) => <Text strong>{v || '-'}</Text>,
        },
        {
            title: '报文时间',
            dataIndex: 'report_time',
            key: 'report_time',
            width: 140,
            render: (d) => (d ? dayjs(d).format('MM-DD HH:mm') : '-'),
        },
        {
            title: '来源',
            dataIndex: 'source',
            key: 'source',
            width: 70,
            render: (v) => renderTag(SOURCE_MAP, v),
        },
        {
            title: '比对结果',
            key: 'comparison',
            width: 220,
            render: (_, record) => {
                const diff = record.scm_only_count + record.ledger_only_count;
                return (
                    <Space size={8}>
                        <Text type="secondary">SCM</Text>
                        <Text strong>{record.uld_total}</Text>
                        <Text type="secondary">/</Text>
                        <Text type="secondary">差异</Text>
                        {diff > 0
                            ? <Text strong style={{ color: '#ff4d4f' }}>{diff}</Text>
                            : <Text style={{ color: '#52c41a' }}>0</Text>
                        }
                        {record.damaged_count > 0 && (
                            <>
                                <Text type="secondary">/</Text>
                                <Text type="secondary">损坏</Text>
                                <Text style={{ color: '#fa8c16' }}>{record.damaged_count}</Text>
                            </>
                        )}
                    </Space>
                );
            },
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: 90,
            render: (v) => renderTag(STATUS_MAP, v),
        },
        {
            title: '解析时间',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 140,
            render: (d) => (d ? dayjs(d).format('MM-DD HH:mm:ss') : '-'),
        },
        {
            title: '操作',
            key: 'action',
            fixed: 'right',
            width: 120,
            render: (_, record) => {
                const ignorable = record.status === 'pending' || record.status === 'parse_failed';
                return (
                    <Space size="small">
                        <Button type="link" size="small" icon={<EyeOutlined />} onClick={() => onView(record)}>
                            查看
                        </Button>
                        <PermissionGuard permission="uld:scm_inbound:confirm">
                            <Popconfirm
                                title="忽略该记录？"
                                okText="忽略"
                                cancelText="取消"
                                disabled={!ignorable}
                                onConfirm={() => onIgnore(record)}
                            >
                                <Button type="link" size="small" danger icon={<StopOutlined />} disabled={!ignorable}>
                                    忽略
                                </Button>
                            </Popconfirm>
                        </PermissionGuard>
                    </Space>
                );
            },
        },
    ];

    return (
        <Table
            columns={columns}
            dataSource={dataSource}
            loading={loading}
            pagination={pagination}
            onChange={onChange}
            rowKey="id"
            scroll={{ x: 900 }}
            size="small"
            onRow={(record) => ({
                style: (record.scm_only_count > 0 || record.ledger_only_count > 0)
                    ? { background: '#fff7e6' }
                    : undefined,
            })}
        />
    );
};

export default ScmInboundTable;
